interface MutedVideoIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function MutedVideoIcon({ color = 'currentColor', ...props }: MutedVideoIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.7937V14.0002C6 14.5525 6.44772 15.0002 7 15.0002H9.18125L12.3858 17.4797C13.1681 18.085 14.2313 17.7675 14.6371 16.9878L6 10.7937ZM14.8037 10.9544V7.70687C14.8037 6.46041 13.3716 5.75775 12.3858 6.52051L10.5749 7.92168L14.8037 10.9544Z"
        fill={color}
      />
      <path
        d="M5 7L19.1421 17.1421"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
